import { render, staticRenderFns } from "./AiChat.vue?vue&type=template&id=050acf7a&scoped=true&"
import script from "./AiChat.vue?vue&type=script&lang=js&"
export * from "./AiChat.vue?vue&type=script&lang=js&"
import style0 from "./AiChat.vue?vue&type=style&index=0&id=050acf7a&scoped=true&lang=css&"
import style1 from "./AiChat.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050acf7a",
  null
  
)

export default component.exports